import React from 'react';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`bg-gradient-to-br from-primary via-primary to-secondary py-20 lg:py-28 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-headline text-white mb-6">
            Human-Centered Leadership for AI Transformation
          </h1>
          <p className="text-lg md:text-xl text-white/90 font-body leading-relaxed mb-8">
            We bridge the critical gap between AI investment and real organizational adoption through proven change management expertise and people-first leadership.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/20">
              <p className="text-white font-semibold font-body">Established 2022</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/20">
              <p className="text-white font-semibold font-body">UK-Based</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/20">
              <p className="text-white font-semibold font-body">Global Reach</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;